import { Button, Divider, Grid, makeStyles, Paper, Typography } from '@material-ui/core/';
import React from 'react';
import LineItems from '../orders/LineItems.jsx';
import PriceLines from '../checkout/PriceLines.jsx';
import PriceLineTotal from '../checkout/PriceLineTotal.jsx';
import Link from 'next/link';

export default ShoppingCartBox;

const useStyles = makeStyles((theme) => ({
  shoppingCart: {
    [theme.breakpoints.up('sm')]: {
      minWidth: 350,
    },
    maxWidth: 400,
    width: '100%',
    borderRadius: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  shoppingCartTitle: {
    fontFamily: 'sofia-bold',
    padding: 20,
  },
  totals: {
    backgroundColor: theme.palette.grey[200],
    padding: 20,
  },
}));

function ShoppingCartBox(props) {
  const { buttonText, meals } = props;
  const classes = useStyles();
  return (
    <Paper elevation={0} className={classes.shoppingCart}>
      <Grid container alignItems='center' className={classes.shoppingCartTitle}>
        <Grid item style={{ flexGrow: 1 }}>
          <Typography variant='body1' style={{ fontFamily: 'sofia-bold' }}>
            My Cart
          </Typography>
        </Grid>
        {buttonText && (
          <Grid item>
            <Link href='/checkout'>
              <Button variant='contained' color='primary' style={{ width: 175 }}>
                {buttonText}
              </Button>
            </Link>
          </Grid>
        )}
        <Divider />
      </Grid>
      <div style={{ flex: '1', overflowY: 'auto' }}>
        <LineItems meals={meals} />


        <div className={classes.totals}>
          <PriceLines variant='simple' />
          <Divider />
          <PriceLineTotal />
        </div>
      </div>
    </Paper>
  );
}
